/*
 * Project: Dynamedics Portal Web
 * Created Date: Thursday November 9th 2023
 * Author: KasunSKarunasekara
 * -----
 * Last Modified: Friday November 10th 2023 1:37:11 pm
 * Modified By: KasunSKarunasekara at <kkarunasekara@mitrai.com>
 * -----
 * Copyright (c) 2023 Mitra Sparks
 * -----
 * HISTORY:
 */

import { createSlice } from '@reduxjs/toolkit';
import { checkUndefinedOrNull } from 'src/utils/functions';
import axios from '../../utils/axios';

const initialState = {
  betaEnabled: true
};

const slice = createSlice({
  name: 'betaFeatures',
  initialState,
  reducers: {
    //DELETE INTEGRATE REPORTS
    setBetaStatus(state, action) {
      state.betaEnabled = action.payload;
    }
  }
});

export default slice.reducer;

// Actions
export const { setBetaStatus } = slice.actions;

// ----------------------------------------------------------------------

export function getAttachedSuppliers() {
  const isAlreadyAttached = true;
  return async (dispatch) => {
    dispatch(slice.actions.startAttachedSuppliersLoading());
    try {
      const response = await axios.get('/supplier', {
        params: {
          isAlreadyAttached
        }
      });
      dispatch(slice.actions.getAttachedSuppliersSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
